import type { JSX } from 'react';

/**
 * ExceptionQueuePage — stub. Requires staff:admin role.
 * Full implementation coming in a future story.
 */
export function ExceptionQueuePage(): JSX.Element {
  return (
    <div className="p-8">
      <h1 className="text-2xl font-semibold text-gray-900">Exception Queue</h1>
      <p className="mt-2 text-gray-500">Coming in a future story.</p>
    </div>
  );
}
